import {useMemo} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {appendQueryString} from "@pg-mono/request";

import {InquiryButtonTypeName} from "../../../../constants/inquiry_button_type";
import {ApplicationModalButton} from "../../../application/components/ApplicationModalButton";
import {GTMEventApplicationSourceSection} from "../../../application/types/lead/GTMEvenApplicationSourceSection";
import {ApplicationSource, ApplicationSourceSection} from "../../../application/utils/form/application_form_source";
import {vendorViewExternalSiteClick} from "../../../tracking/algolytics_hits/external_site_click";
import {IGTMEventLeadForm} from "../../../tracking/google_tag_manager/gtm_event_form_open";
import {IVendorDetail} from "../../types/IVendorDetail";

interface IProps {
    vendor: IVendorDetail;
    hasActiveOffers: boolean;
}

export const VendorDetailContact = (props: IProps) => {
    const {vendor, hasActiveOffers} = props;
    const vendorTrackedSite = {
        id: vendor.id,
        name: vendor.name,
        slug: vendor.slug
    };

    const gtmData: IGTMEventLeadForm = {
        clickText: InquiryButtonTypeName.VENDOR,
        source: GTMEventApplicationSourceSection.CONTACT_VENDOR_PAGE,
        vendorName: vendor.name,
        offerName: ""
    };

    const websiteUrl = useMemo(() => {
        if (!vendor.website) {
            return null;
        }

        return vendor.configuration?.include_utm
            ? appendQueryString(vendor.website, {
                  utm_campaign: "prezentacja",
                  utm_medium: "referral",
                  utm_source: "rynekpierwotny"
              })
            : vendor.website;
    }, [vendor.website, vendor.configuration?.include_utm]);

    return (
        <>
            <Text as="h2" variant="headline_3" className={headerStyle}>
                Kontakt
            </Text>

            <div className={wrapperStyle}>
                <div className={cardBodyStyle}>
                    {vendor.logo?.v_log_120x90 && <Image src={vendor.logo.v_log_120x90} alt={`${vendor.name} logo`} width="120px" height="90px" />}

                    <Text as="div" variant="headline_5" className={vendorNameStyle}>
                        {vendor.name}
                    </Text>

                    {websiteUrl && (
                        <div className={websiteStyle}>
                            <Button
                                as="a"
                                href={websiteUrl}
                                target="_blank"
                                rel="nofollow"
                                data-gtm-click="Odwiedź stronę dewelopera"
                                onClick={() => vendorViewExternalSiteClick(vendorTrackedSite)}
                                variant="highlight_primary"
                                size="medium"
                            >
                                Strona internetowa inwestycji
                            </Button>

                            <a href={websiteUrl} target="_blank" rel="nofollow" className={css({textAlign: "center"})}>
                                <Text as="span" variant="info_txt_3">
                                    {vendor.website}
                                </Text>
                            </a>
                        </div>
                    )}

                    {vendor.headquarters && (
                        <Text as="address" variant="info_txt_3" className={vendorAddressStyle}>
                            {vendor.headquarters.region.short_name}, {vendor.headquarters.address}
                        </Text>
                    )}

                    {hasActiveOffers && (
                        <ApplicationModalButton
                            vendorId={vendor.id}
                            offerId={null}
                            propertyId={null}
                            source={ApplicationSource.Vendor}
                            sourceSection={ApplicationSourceSection.MODAL}
                            hideQuestions
                            render={({openModal}) => (
                                <Button variant="filled_primary" size="medium" className={inquiryButtonStyle} onClick={() => openModal(gtmData)}>
                                    {InquiryButtonTypeName.VENDOR}
                                </Button>
                            )}
                        />
                    )}
                </div>
            </div>
        </>
    );
};

const headerStyle = css({
    marginBottom: 4
});

const wrapperStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: 3,
    backgroundColor: "var(--colors-white)",
    borderRadius: 2
});

const cardBodyStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: 3,
    gap: 2
});

const vendorNameStyle = css({
    marginBottom: 1
});

const websiteStyle = css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: 1
});

const vendorAddressStyle = css({
    color: "var(--colors-gray-600)",
    fontStyle: "normal"
});

const inquiryButtonStyle = css({
    width: "100%",
    maxWidth: "30rem"
});
import {useMemo} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {appendQueryString} from "@pg-mono/request";

import {InquiryButtonTypeName} from "../../../../constants/inquiry_button_type";
import {ApplicationModalButton} from "../../../application/components/ApplicationModalButton";
import {GTMEventApplicationSourceSection} from "../../../application/types/lead/GTMEvenApplicationSourceSection";
import {ApplicationSource, ApplicationSourceSection} from "../../../application/utils/form/application_form_source";
import {vendorViewExternalSiteClick} from "../../../tracking/algolytics_hits/external_site_click";
import {IGTMEventLeadForm} from "../../../tracking/google_tag_manager/gtm_event_form_open";
import {IVendorDetail} from "../../types/IVendorDetail";

interface IProps {
    vendor: IVendorDetail;
    hasActiveOffers: boolean;
}

export const VendorDetailContact = (props: IProps) => {
    const {vendor, hasActiveOffers} = props;
    const vendorTrackedSite = {
        id: vendor.id,
        name: vendor.name,
        slug: vendor.slug
    };

    const gtmData: IGTMEventLeadForm = {
        clickText: InquiryButtonTypeName.VENDOR,
        source: GTMEventApplicationSourceSection.CONTACT_VENDOR_PAGE,
        vendorName: vendor.name,
        offerName: ""
    };

    const websiteUrl = useMemo(() => {
        if (!vendor.website) {
            return null;
        }

        return vendor.configuration?.include_utm
            ? appendQueryString(vendor.website, {
                  utm_campaign: "prezentacja",
                  utm_medium: "referral",
                  utm_source: "rynekpierwotny"
              })
            : vendor.website;
    }, [vendor.website, vendor.configuration?.include_utm]);

    return (
        <>
            <Text as="h2" variant="headline_3" className={headerStyle}>
                Kontakt
            </Text>

            <div className={wrapperStyle}>
                <div className={cardBodyStyle}>
                    {vendor.logo?.v_log_120x90 && <Image src={vendor.logo.v_log_120x90} alt={`${vendor.name} logo`} width="120px" height="90px" />}

                    <Text as="div" variant="headline_5" className={vendorNameStyle}>
                        {vendor.name}
                    </Text>

                    {websiteUrl && (
                        <div className={websiteStyle}>
                            <Button
                                as="a"
                                href={websiteUrl}
                                target="_blank"
                                rel="nofollow"
                                data-gtm-click="Odwiedź stronę dewelopera"
                                onClick={() => vendorViewExternalSiteClick(vendorTrackedSite)}
                                variant="highlight_primary"
                                size="medium"
                            >
                                Strona internetowa inwestycji
                            </Button>

                            <a href={websiteUrl} target="_blank" rel="nofollow" className={css({textAlign: "center"})}>
                                <Text as="span" variant="info_txt_3">
                                    {vendor.website}
                                </Text>
                            </a>
                        </div>
                    )}

                    {vendor.headquarters && (
                        <Text as="address" variant="info_txt_3" className={vendorAddressStyle}>
                            {vendor.headquarters.region.short_name}, {vendor.headquarters.address}
                        </Text>
                    )}

                    {hasActiveOffers && (
                        <ApplicationModalButton
                            vendorId={vendor.id}
                            offerId={null}
                            propertyId={null}
                            source={ApplicationSource.Vendor}
                            sourceSection={ApplicationSourceSection.MODAL}
                            hideQuestions
                            render={({openModal}) => (
                                <Button variant="filled_primary" size="medium" className={inquiryButtonStyle} onClick={() => openModal(gtmData)}>
                                    {InquiryButtonTypeName.VENDOR}
                                </Button>
                            )}
                        />
                    )}
                </div>
            </div>
        </>
    );
};

const headerStyle = css({
    marginBottom: 4
});

const wrapperStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: 3,
    backgroundColor: "var(--colors-white)",
    borderRadius: 2
});

const cardBodyStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: 3,
    gap: 2
});

const vendorNameStyle = css({
    marginBottom: 1
});

const websiteStyle = css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: 1
});

const vendorAddressStyle = css({
    color: "var(--colors-gray-600)",
    fontStyle: "normal"
});

const inquiryButtonStyle = css({
    width: "100%",
    maxWidth: "30rem"
});
